// extracted by mini-css-extract-plugin
module.exports = {"Advantage":"Advantage_Advantage__3fwGG","Item":"Advantage_Item__SBSN9","Title":"Advantage_Title__3wS4K","Description":"Advantage_Description__3WRaV","Icon":"Advantage_Icon__I-ama"};